/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cps: NonNullable<unknown> }} Event_Warning_Cps_TitleInputs */

const en_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS warning: CPS (${i?.cps}) is above max value`)
};

const fr_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alerte CPS : le CPS (${i?.cps}) dépasse la valeur maximale`)
};

const de_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS-Warnung: CPS (${i?.cps}) liegt über dem Maximalwert`)
};

const it_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avviso CPS: CPS (${i?.cps}) è superiore al valore massimo`)
};

const ru_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предупреждение CPS: значение CPS (${i?.cps}) превышает максимальное значение.`)
};

const es_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Advertencia de CPS: CPS (${i?.cps}) está por encima del valor máximo`)
};

const zh_cn2_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS 警告：CPS (${i?.cps}) 高于最大值`)
};

const ja_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CPS警告: CPS (${i?.cps})が最大値を超えています`)
};

const hi_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सीपीएस चेतावनी: सीपीएस (${i?.cps}) अधिकतम मान से अधिक है`)
};

const pt_pt2_event_warning_cps_title = /** @type {(inputs: Event_Warning_Cps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aviso do CPS: O CPS (${i?.cps}) está acima do valor máximo.`)
};

/**
* | output |
* | --- |
* | "CPS warning: CPS ({cps}) is above max value" |
*
* @param {Event_Warning_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_cps_title = /** @type {((inputs: Event_Warning_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_cps_title(inputs)
	if (locale === "de") return de_event_warning_cps_title(inputs)
	if (locale === "it") return it_event_warning_cps_title(inputs)
	if (locale === "ru") return ru_event_warning_cps_title(inputs)
	if (locale === "es") return es_event_warning_cps_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_cps_title(inputs)
	if (locale === "ja") return ja_event_warning_cps_title(inputs)
	if (locale === "hi") return hi_event_warning_cps_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_cps_title(inputs)
	return en_event_warning_cps_title(inputs)
});